
import VueFilters from "@/vue-filters";
import { Component, Prop, Vue } from "vue-property-decorator";
import { COMMODITY_TYPES, ICountryConfig, IField, ISolCustomerCurrency, IValue } from "@/entities";
import { Getter } from "vuex-class";
import { LocaleMessage } from "vue-i18n";
import IconEdit from "@/components/common/icon/IconEdit.vue";
import IconTrash from "@/components/common/icon/IconTrash.vue";
import { PropType } from "vue";

@Component({
  name: "declared-value-details",
  components: { IconTrash, IconEdit },
  mixins: [VueFilters],
})
export default class DeclaredValueDetails extends Vue {
  @Prop({ required: false, default: () => [], type: Array as PropType<IValue[]> })
  values!: IValue[];
  @Prop({ required: false, default: "0" }) mode!: string;
  @Prop({ required: false, default: false, type: Boolean }) edit!: boolean;
  @Getter("getCountryConfig") countryConfig!: ICountryConfig;
  @Getter("getSolCustomerCurrencies") solCustomerCurrencies!: ISolCustomerCurrency[];

  get visibleFieldsValues(): IField[] {
    return this.fieldsValues.filter((field) => field.visible !== false);
  }

  get fieldsValues(): IField[] {
    return [
      {
        key: "actions-left",
        label: "",
        sortable: false,
        thClass: "table-header table-header-active pl-4",
        tdClass: "table-cell-first align-middle position-relative",
      },
      {
        key: "type",
        label: this.$t("column.type") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
        visible: this.mode === "0",
        formatter: (_value: number, _key: string, item: IValue): LocaleMessage | string => {
          return item.sc ? this.$t("label.seal") : this.$t("label.bag");
        },
      },
      {
        key: "co",
        label: this.$t("column.code") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
        visible: this.mode === "0",
        formatter: (_value: number, _key: string, item: IValue): string => {
          return item.sc || item.bc || "";
        },
      },
      {
        key: "ctc",
        label: this.$t("label.agilePickup.commodity") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
        formatter: (value: string): string => {
          switch (value) {
            case COMMODITY_TYPES.BILL:
              return this.$t("label.bills").toString();
            case COMMODITY_TYPES.COIN:
              return this.$t("label.coins").toString();
            case COMMODITY_TYPES.CASH:
              return this.$t("label.cash").toString();
            default:
              return "";
          }
        },
      },
      {
        key: "am",
        label: this.$t("column.amount") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
      },
      {
        key: "actions-right",
        label: "",
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-last align-middle",
      },
    ];
  }

  onClickEdit(value: IValue): void {
    this.$emit("edit", value);
  }

  onClickDelete(value: IValue): void {
    this.values.splice(this.values.indexOf(value), 1);
  }

  getCurrencySymbol(currencyIsoCode: string): string {
    const currency = this.solCustomerCurrencies.find(
      (currency) => currency.isoCode === currencyIsoCode
    );
    return currency?.symbol || "";
  }
}
